import { Button } from '@pets-ui/Button/Button'
import { useTranslation } from 'react-i18next'
import { useCampaign } from '../hooks/use-campaign'
import style from '../style/components/thankyou-footer.module.scss'

export const ThankyouFooter = () => {
  const { campaignCodeFromUrl } = useCampaign()
  const { t } = useTranslation()

  const handleClickBackToHomepage = () => {
    // NOTE: Remove all state
    window.location.href = `/campaigns/${campaignCodeFromUrl}/`
  }

  return (
    <div className={style['thankyou-footer']}>
      <Button fullWidth onClick={handleClickBackToHomepage}>
        {t('button.backToHomepage')}
      </Button>
    </div>
  )
}
